import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ standalone: false, name: 'calculateDiscount' })
export class CalculateDiscount implements PipeTransform {
  transform(discount: any) {
    if((discount && String(discount).includes("NaN")) || !discount || discount === "" || discount === 0.0) {
      discount = undefined;
    } else {
      discount = Math.round(discount*100);
      return discount;
    }
  }
}
